<!-- Top Banner Section -->
<header class="contact-banner" role="banner">
  <div class="contact-banner__overlay d-flex justify-content-center align-items-center">
    <h1 class="ff-poppins-bold m-0">Contact us</h1>
  </div>
</header>

<!-- Main Content Section -->
<main
  class="contact-hero d-flex flex-wrap justify-content-between p-4 p-md-5 mx-3 mx-md-4 my-4 mb-5"
>
  <section class="contact-info-box col-12 col-lg-5" aria-labelledby="contact-heading">
    <div class="eyebrow d-flex align-items-center mb-2">
      <span class="rule me-2"></span>
      <span class="label ff-poppins-light">Let's Get in Touch</span>
    </div>
    <h2 id="contact-heading" class="ff-poppins-semibold mb-3 me-3 contact-title">
      Reach Out Anytime, Anywhere
    </h2>
    <p class="contact-info-box__desc ff-outfit">
      Whether you have questions about our services, need support with your booking, or want to
      partner with us — we’re just a message away.
    </p>
    <p class="contact-info-box__desc ff-outfit">
      Our team is ready to assist you with anything you need, anytime, anywhere.
    </p>
    <address class="m-0">
      <div
        class="contact-info-box__method d-flex align-items-center mt-4 mb-3"
        aria-label="WhatsApp contact"
      >
        <span class="icon-badge d-flex justify-content-center align-items-center">
          <img src="/icons/ic_whatsapp.svg" alt="WhatsApp icon" width="22" height="22" />
        </span>
        <div class="d-flex flex-column ms-3">
          <span class="contact-info-box__method-label">WhatsApp</span>
          <a
            class="contact-info-box__method-value ff-poppins-medium m-0 text-decoration-none"
            href="tel:{{ supportPhone }}"
            >{{ supportPhone }}</a
          >
        </div>
      </div>
      <div class="contact-info-box__method d-flex align-items-center" aria-label="Email contact">
        <span class="icon-badge d-flex justify-content-center align-items-center">
          <img src="/icons/ic_mail.svg" alt="Email icon" width="22" height="22" />
        </span>
        <div class="d-flex flex-column ms-3">
          <span class="contact-info-box__method-label">Email</span>
          <a
            class="contact-info-box__method-value ff-poppins-medium m-0 text-decoration-none"
            href="mailto:{{ supportEmail }}"
            >{{ supportEmail }}</a
          >
        </div>
      </div>
    </address>
  </section>
  <div class="col-12 col-lg-6 d-flex justify-content-center justify-content-lg-end mt-4 mt-lg-0">
    <img
      src="/images/contact-us-img.png"
      alt="Two luxury cars representing our contact support"
      class="contact-visual"
      loading="lazy"
      decoding="async"
    />
  </div>
</main>
